// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__FjdTn","prevNextPageBtn":"styles_prevNextPageBtn__1jY6B","text":"styles_text__2r5Jj","input":"styles_input__3v6Ji","select":"styles_select__1MrzN"};